
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { ImageUploader } from "./ImageUploader";

interface SEOSettingsProps {
  title: string;
  metaDescription: string;
  metaKeywords: string;
  ogImage: string;
  onUpdate: (field: string, value: string) => void;
}

export function SEOSettings({
  title,
  metaDescription,
  metaKeywords,
  ogImage,
  onUpdate
}: SEOSettingsProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>SEO Settings</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <Label>Page Title</Label>
          <Input
            value={title}
            onChange={(e) => onUpdate('title', e.target.value)}
            placeholder="Restaurant Name - Best Food in City"
            maxLength={60}
          />
          <p className="text-xs text-muted-foreground mt-1">
            {title.length}/60 characters (optimal for search results)
          </p>
        </div>

        <div>
          <Label>Meta Description</Label>
          <Textarea
            value={metaDescription}
            onChange={(e) => onUpdate('meta_description', e.target.value)}
            placeholder="Delicious authentic cuisine in the heart of the city. Fresh ingredients, warm atmosphere, and exceptional service."
            maxLength={160}
            rows={3}
          />
          <p className="text-xs text-muted-foreground mt-1">
            {metaDescription.length}/160 characters (optimal for search results)
          </p>
        </div>

        <div>
          <Label>Keywords</Label>
          <Input
            value={metaKeywords}
            onChange={(e) => onUpdate('meta_keywords', e.target.value)}
            placeholder="restaurant, food, dining, cuisine, local"
          />
          <p className="text-xs text-muted-foreground mt-1">
            Separate keywords with commas
          </p>
        </div>

        <ImageUploader
          currentUrl={ogImage}
          onImageUpload={(url) => onUpdate('og_image', url)}
          section="og-image"
          label="Social Media Preview Image (Open Graph)"
          placeholder="Upload image for social media previews"
        />
        <p className="text-xs text-muted-foreground">
          Recommended size: 1200x630px for best social media previews
        </p>
      </CardContent>
    </Card>
  );
}
